import getTimeZoneOperation from 'owa-service/lib/operation/getTimeZoneOperation';
export default function getTimeZone() {
    return getTimeZoneOperation({
        needTimeZoneList: true,
    }).then(function (response) { return response.TimeZoneList; });
}
//# sourceMappingURL=getTimeZone.js.map